export default __webpack_public_path__ + "static/media/Winter_06.c3fb0ae4.png";